module.exports = __webpack_public_path__ + "img/Kraftfahrzeug.652171cf.svg";